import { ReactElement, useMemo } from "react";

import { Grid, Header, Image, Progress } from "semantic-ui-react";

import CONFIG from "config/config";

const IMAGES = {
  ishealth: "images/IHlogo.png",
  mehealth: "/static/images/landing/mehealth-logo.png",
  mehey:"/static/images/landing/mehey-logo.png"
};

const LOGOS: Partial<Record<typeof CONFIG.COMPANY, ReactElement>> = {
  MEHEALTH: <Image style={{ width: "175px" }} src={IMAGES.mehey} centered />,
};

const TITLES: Partial<Record<typeof CONFIG.COMPANY, ReactElement>> = {
  MEHEALTH: (
    <span style={{ fontSize: "2rem" }}>
      กำลังเข้าสู่ระบบ <span style={{ color: "var(--primary-theme-color)" }}>MeHey</span>{" "}
      กรุณารอสักครู่
    </span>
  ),
};

const LoadingScreen = () => {
  const logo = useMemo(() => LOGOS[CONFIG.COMPANY] ?? <Image src={IMAGES.ishealth} centered />, []);

  const title = useMemo(
    () => TITLES[CONFIG.COMPANY] ?? <>...Please wait while loading info...</>,
    []
  );

  return (
    <div
      style={{
        alignItems: "center",
        display: "flex",
        fontSize: "3rem",
        height: "100%",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Grid reversed="tablet vertically">
        <Grid.Row>
          <Grid.Column>{logo}</Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column>
            <Header textAlign="center">
              <Header.Content>{title}</Header.Content>
            </Header>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column>
            <Header textAlign="center">
              <Header.Content>
                <Progress
                  className="loading-info"
                  style={{ width: "750px" }}
                  percent={100}
                  size="small"
                  active
                />
              </Header.Content>
            </Header>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default LoadingScreen;
